import { TranslateService } from "@ngx-translate/core";
import { NewsDetailsModalComponent } from "./../news-details-modal/news-details-modal.component";
import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { CompanyNews } from "src/app/models/company-news";
import { MatDialog } from "@angular/material/dialog";
import { SignalRService } from "src/app/services/signalr.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-news",
  templateUrl: "./news.component.html",
  styleUrls: ["./news.component.scss"],
})
export class NewsComponent implements OnInit {
  @Input() symbolCode: string;
  @Input() reuters: string;
  @Input() companyName: string;
  @Input() wasChanged: boolean;

  isNewsLoading: boolean;
  companyNews: CompanyNews[];

  isNewsView = true;
  announcements: CompanyNews[];

  setNewsView(value) {
    this.isNewsView = value;
  }
  constructor(
    public dialog: MatDialog,
    public translate: TranslateService,
    private _service: ApiService,
    signalService: SignalRService
  ) {
    // signalService.connectBidsAsksUpdates();

    signalService.newsChanges.subscribe((res: any) => {
      res.forEach((element: CompanyNews) => {
        if (element.SYMBOL_CODE == this.symbolCode)
          switch (element.TYPE) {
            case 1:
              this.companyNews?.unshift(element);
            default:
              this.announcements?.unshift(element);
          }
        // this.companyNews = res.filter((book) => book.TYPE === 1);
        // this.announcements = res.filter((book) => book.TYPE != 1);
      });
    });
  }

  ngOnInit() {
    this.companyNews = [];
  }

  ngOnChanges(changes: SimpleChanges) { 
     if( (this.wasChanged == false && changes.wasChanged?.currentValue != null) || changes.wasChanged?.previousValue == null){
    if (changes.companyName?.currentValue != null) {
      if (changes.companyName?.currentValue != changes.companyName?.previousValue) {
        this.companyName = changes.companyName.currentValue;
      }
    }
    this.reuters = changes.reuters?.currentValue;
    this.companyName = changes.companyName?.currentValue;
    this.symbolCode = changes.symbolCode?.currentValue;
    if (this.symbolCode) this.fetchCompanyNews();
  }
  }

  openNewsModal(item) {
    this.dialog.open(NewsDetailsModalComponent, {
      panelClass: "custom-dialog-container",
      data: {
        item,
      },
    });
  }

  fetchCompanyNews() {
    this.isNewsLoading = true;

    this._service.fetchCompanyNews(this.symbolCode).subscribe((res) => {
      this.isNewsLoading = false;

      if (res) {
        this.companyNews = res.filter((book) => book.TYPE === 1);
        this.announcements = res.filter((book) => book.TYPE != 1);
      }
    });
  }

  getColor(item) {
    switch (item) {
      case 1:
        return {
          background: "aquamarine",
          color: "black",
        };
      case 2:
        return {
          background: "bisque",
          color: "black",
        };
      case 3:
        return {
          background: "teal",
          color: "whitesmoke",
        };
      case 4:
        return {
          background: "greenyellow",
          color: "black",
        };
      case 5:
        return {
          background: "cornflowerblue",
          color: "black",
        };
      case 6:
        return {
          background: "darkorange",
          color: "black",
        };
      case 7:
        return {
          background: "darkslategrey",
          color: "white",
        };
      case 8:
        return {
          background: "yellow",
          color: "black",
        };
      case 9:
        return {
          background: "violet",
          color: "white",
        };
      case 12: {
        return {
          background: "lightcoral",
          color: "whitesmoke",
        };
      }
      default: {
        return {
          background: "lightgray",
          color: "black",
        };
      }
    }
  }
}
